import styled, { DefaultTheme } from 'styled-components';

type TWhiteSpace = keyof DefaultTheme['spacing'];

const WhiteSpace = styled.div<{ spacing: TWhiteSpace }>`
  min-height: ${({ theme, spacing }) => theme.spacing[spacing]};
`;

export { WhiteSpace };
